import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('eileen_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default client;
